/**************************************************************************************************
 *
 *  This is the main container for all project related views: Project Detail (hierarch), Project
 *  Edit/Creation, Build Edit/Creation, Task Detail, Field Task Detail
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
**************************************************************************************************/

import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import UserAvatar from '../../../components/UserAvatar';
import ReplaceProjectMemberPopup from './ReplaceProjectMemberPopup';
import SelectProjectMemberPopup from './SelectProjectMemberPopup';
import ProjectContact from './ProjectContact';
import ComboBox from '../../../components/ComboBox';
import LoadingDots from '../../../components/LoadingDots';
import DataCollector from '../../../components/DataCollector';
import SelectUserComboBox from '../../../components/SelectUserComboBox';
import dataModel from '../../../models/DataModel';
import { location_shallow } from '../../../dao/collections/LocationsCollection';
import DatePicker from '../../../components/DatePicker';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import { project_type_root } from '../../../dao/ProjectTypesDAO';
import { location_root } from '../../../dao/collections/LocationsCollection';
import projectsService from '../../../services/projectsService'; 
import DataSource from '../../../dao/DataSource/DataSource';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import locationsService from '../../../services/locationsService';
import KeyMemberDisplay from '../../../components/KeyMemberDisplay';
import CreateNewProjectGroup from './CreateNewProjectGroup';
import ProjectGroupService from '../../../services/projectGroupService';
import './ProjectCRUD.scss';
import Input from '../../../components/Input';
import Textarea from '../../../components/Textarea';

const user_complete = {
  additionalFields: ['profile_image'], role: { }, companies: { }, company_vendor_users: { vendor_user: { additionalFields: ['profile_image'], role: { }, companies: { } } }, 
};

export const project_for_edit = {
  project: {
    project_manager: {
      role: {},
      companies: {},
    },
    project_type: {},
    project_template: {},
    location: { market: {}, location_users: { user: {} } },
    market: {},
    project_users: { user: {} },
    project_contacts: { user: {} },
    users: user_complete,
    company: {},
    customers: {},
    custom_project_settings: {},
    teams: { users: {} },
    isSaving: false,
  },
};

const projectTypeDescriptor = { 
  project_type: {
    project_templates: {
      markets: {},
    },
  },
};

const intialProjectGroupListButton = { type: 'create', name: '+ Create Project Group' };

// TODO: reduce complexity / break into sub-components
export class ProjectCRUD extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.customFieldTypes = [
      { type: '1', name: 'Text' },
      { type: '2', name: 'Decimal' },
      { type: '3', name: 'Integer' },
      { type: '4', name: 'Yes/No' },
      { type: '5', name: 'Selection List' },
    ];

    this.state = {
      selectedUser: null,
      project: null,
      customSetting: this.emptyCustomSetting,
      markets: null,
      marketLocations: null,
      selectedMarketId: null,
      currentMarketId: null,
      loadingLocations: false,
      loadingMarkets: false,
      loadingProjectTypes: false,
      starting: true,
      allMarketUsers: [],
      projectGroups: [intialProjectGroupListButton],
      selectedGroup: null,
      totalLocation: null,
      locationsList: null,
    };

    this.handleSaveProjectGroup = this.handleSaveProjectGroup.bind(this);
    this.getMarkets = this.getMarkets.bind(this);
    this.getLocations = this.getLocations.bind(this);
    this.createMarketOptions = this.createMarketOptions.bind(this);
    this.createLocationOptions = this.createLocationOptions.bind(this);
    this.handleSearchLocation = this.handleSearchLocation.bind(this);
  }

  handleProjectRetrieve(project, action, acData, fetchedData) {
    if (action === 'prefetch') {
      // TODO: loading indicator?
    }
    else if (acData && acData.type === 'updateProjectMemberAssignments') {
      this.projectDataSource.get();
    }
    else if (acData) {
      // ignore if I'm already editing
      if (!this.state.projectHasBeenEdited && fetchedData) {
        this.setState({ project: fetchedData });
      }
    }
    else if (action === 'update') {
      let stateProject = _.cloneDeep(this.state.project);
      stateProject.project_type_id = project.project_type_id;
      stateProject.project_template_id = project.project_template_id;
      this.handleFinishProjectUpdate(stateProject);
    }
    else {
      let updatedProject;
      if (this.state.projectHasBeenEdited) {
        updatedProject = _.cloneDeep(this.state.project);
        // just copy what don't control but care about
        updatedProject.project_users = project.project_users;
        updatedProject.users = project.project_users.map(pu => { return pu.user; });
      }
      else {
        updatedProject = project;
      }
      this.setState({ project: updatedProject });

      if (project.market) {
        this.getProjectManagers(project.market);
        this.getLocations(true, project.market);
      }
      let fieldWidth = 0;

      let element = document.getElementById('customFieldField');

      if (element) {
        const rect = element.getBoundingClientRect();
        fieldWidth = rect.width;
      }
      if (!this.state.customFieldWidth || Math.round(this.state.customFieldWidth) != Math.round(fieldWidth)) {
        this.setState({ customFieldWidth: fieldWidth });
      }

      if (project.market && project.market.id) {
        this.usersDataSource = new CollectionDataSource('MarketUsersCollection', 'User', { user: {} }, this.handleUsersRetrieval, null, null, null, null, null, project.market.id);
        this.usersDataSource.current();
      }
  
      this.getMarkets();
    }

    if(project && project.project_group_id){
      ProjectGroupService.getProjectGoupById(this.props.currentCompany.id, project.project_group_id)
      .then(res=>{
        let projectGroup = {
          type: res.data.id,
          id: res.data.id,
          name: res.data.attributes.name,
        };
        this.setState({ selectedGroup: projectGroup });
      });
    }
  }

  handleCompanyUpdate(company, action) {
    this.setState({ customers: company.customers });
  }

  handleUsersRetrieval(marketUsers, action, acData, fetchedData) {
    if (marketUsers) {
      this.setState({ allMarketUsers: marketUsers.users });
    }
  }

  async handleProjectGroupsRetrieval() {
    ProjectGroupService.getProjectGroups(this.props.currentCompany.id).then(response=>{
      const projectGroups = [];
      response.data.map(rs=>{
        let pg = {
          type: rs.id,
          id: rs.id,
          name: rs.attributes.name,
        };
        projectGroups.push(pg);
      });
      this.setState({ projectGroups: [intialProjectGroupListButton, ...projectGroups] });
    });
  }

  componentDidMount() {
    this._isMounted = true;
    super.componentDidMount(this);
    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    if (this.props.params.project_id) {
      this.projectDataSource = new DataSource('Project', +this.props.params.project_id, project_for_edit, this.handleProjectRetrieve);
      this.projectDataSource.get();

      this.companyDataSource = new DataSource('Company', this.props.currentCompany.id, { company: { customers: {} } }, this.handleCompanyUpdate);
      this.companyDataSource.get();
    }
    const createLocationList =  this.createLocationOptions();
    this.setState({ locationsList: createLocationList }); 

    this.isRequiredFieldsAreEmpty();
    this.handleProjectGroupsRetrieval();
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate(this);
    let element = document.getElementById('customFieldField');
    if (!this.state.customFieldWidth || (this.state.customFieldWidth === -1 && element)) {
      let fieldWidth = -1;
      if (element) {
        const rect = element.getBoundingClientRect();
        fieldWidth = rect.width;
      }
      if (!this.state.customFieldWidth || Math.round(this.state.customFieldWidth) != Math.round(fieldWidth)) {
        this.setState({ customFieldWidth: fieldWidth });
      }
    }
    if(prevState.marketLocations !== this.state.marketLocations){
      const createLocationList =  this.createLocationOptions();
      this.setState({ locationsList: createLocationList });
    }

    this.isRequiredFieldsAreEmpty();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.companyDataSource) {
      this.companyDataSource.release();
      this.companyDataSource = null;
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    if (this.locationsDataSource) {
      this.locationsDataSource.release();
      this.locationsDataSource = null;
    }
    if (this.usersDataSource) {
      this.usersDataSource.release();
      this.usersDataSource = null;
    }
    if (this.marketsDataSource) {
      this.marketsDataSource.release();
      this.marketsDataSource = null;
    }
    if (this.projectTypesDataSource) {
      this.projectTypesDataSource.release();
      this.projectTypesDataSource = null;
    }
    if (this.projectManagersDataSource) {
      this.projectManagersDataSource.release();
      this.projectManagersDataSource = null;
    }
    if (this.locationDataSource) {
      this.locationDataSource.release();
      this.locationDataSource = null;
    }
    if (this.projectTypeDataSource) {
      this.projectTypeDataSource.release();
      this.projectTypeDataSource = null;
    }
  }

  handleMarketsRetrieval(markets) {
    const { project } = this.state;
    this.setState({ markets, loadingMarkets: false });
    if (project && project.market) {
      this.setState({ selectedMarketId: project.market.id }, () => {
        this.marketSelected();
      });
    }
  }

  getMarkets() {
    if (!this.state.markets) {
      this.setState({ loadingMarkets: true, starting: false });
      this.marketsDataSource = new CollectionDataSource('MarketsCollection', 'Market', { market: {} }, this.handleMarketsRetrieval,
        'MarketsForProjectCrud', this.props.currentUser.id, this.props.currentCompany.id);
      this.marketsDataSource.current();
    }
    else {
      return this.state.markets;
    }
  }

  handleMarketSelection(type, option) {
    const { project } = this.state;
    if (!project.market || project.market.id != option.type) {
      this.new_project_type = null;
      this.new_project_template = null;
      this.handleProjectFieldChange('market', option.market, true);
      // Changing the market refetches the project types and templates, so the
      // project's existing type/template may no longer be valid for the new
      // market. Clear them so the pickers reset and the user must re-select.
      project.project_type = null;
      project.project_type_id = null;
      project.project_template = null;
      project.project_template_id = null;
      this.setState({ project, selectedMarketId: option.type }, () => {
        this.marketSelected(option.market);
      });
    }
  }

  marketSelected(market) {
    this.getLocations(true, market);
    this.getProjectTypes(market);
    this.getProjectManagers(market);
  }

  handleLocationsSet(currentData) {
    if (currentData) {
      this.setState({ marketLocations: currentData.locations, currentMarketId: this.state.selectedMarketId, loadingLocations: false }, () => {
      });
      if(!this.state.totalLocation){
        this.setState({ totalLocation: currentData.meta.total_records });
      }
    }
  }

  handleLocationsRetrieved(currentData, action, acData, fetchedData) {
    this.handleLocationsSet(currentData);
  }

  getLocations(init, market) {
    if (init || !this.state.marketLocations || this.state.currentMarketId != this.state.selectedMarketId) {
      this.setState({ loadingLocations: true, starting: false });
      if (this.locationsDataSource) {
        this.locationsDataSource.release();
        this.locationsDataSource = null;
      }
  
      this.locationsDataSource = new CollectionDataSource('LocationsCollection', 'Location', location_shallow,
        this.handleLocationsRetrieved, 'forProjectCrud', 12, null, this.props.currentUser.id,
        this.props.currentCompany.id, 'market_' + (market ? market.id : this.state.selectedMarketId), null, location_shallow,
        (market ? market.id : this.state.selectedMarketId));
      this.locationsDataSource.current();
    }
    else {
      return this.state.marketLocations;
    }
  }

  handleProjectManagersRetrieval(projectManagers) {
    const { project } = this.state;
    const projectManagerExistsForMarket = projectManagers.filter((projectManager) => {
      return projectManager.markets.includes(project.market_id);
    });
    this.setState({ projectManagers: projectManagerExistsForMarket }, () => {
      // ensure current project manager (if any) is valid
      if (project.project_manager) {
        const projectManagerExistsForMarket = projectManagers.find((projectManager) => {
          return projectManager.id === project.project_manager.id;
        });
        if (!projectManagerExistsForMarket) {
          project.project_manager_id = null;
          delete project.project_manager;
          this.setState({ project });
        }
      }
    });
  }

  getProjectManagers(market) {
    this.projectManagersDataSource = new DataSource('User', null, null, this.handleProjectManagersRetrieval);
    this.projectManagersDataSource.performAction('getProjectManagers', market);
  }

  handleProjectTypesRetrieval(project_types, action) {
    // The datasource fires this callback twice: a synchronous 'prefetch' pass with the
    // cached collection object (before the /project_types request resolves) and again
    // with the real array. Ignore the prefetch pass so we don't clobber project_types
    // with stale data. Loading is driven off the fetch promise in getProjectTypes().
    if (action === 'prefetch') {
      return;
    }
    if (project_types) {
      this.setState({ project_types: project_types }, () => {
        const { project } = this.state;
        if (project.project_template || this.currentProjectTemplate) {
          // ensure currently configured project template belongs to
          // new market...
          const projectTemplateToCheck = project.project_template ? project.project_template : this.currentProjectTemplate;
          const projectTypesForMarket = this.getProjectTypesForMarket(this.state.selectedMarketId);
          const templateExistsForMarket = projectTypesForMarket.find((projectType) => {
            if (projectType.project_templates) {
              return projectType.project_templates.find((projectTemplate) => {
                return projectTemplate.id === projectTemplateToCheck.id;
              });
            }
            return false;
          });
          if (!templateExistsForMarket) {
            if (!this.currentProjectTemplate) {
              this.currentProjectType = project.project_type;
              this.currentProjectTemplate = project.project_template;
            }
            project.project_type = undefined;
            project.project_template = undefined;
            this.setState({ project });
          } else if (this.currentProjectTemplate) {
            project.project_type = this.currentProjectType;
            project.project_template = this.currentProjectTemplate;
            this.currentProjectType = undefined;
            this.currentProjectTemplate = undefined;
            this.setState({ project });
          }
        }
      });
    }
  }

  getProjectTypes(market) {
    this.setState({ loadingProjectTypes: true });
    this.projectTypesDataSource = new CollectionDataSource('ProjectTypesCollection', 'ProjectTypes', projectTypeDescriptor,
      this.handleProjectTypesRetrieval, 'ProjectTypesForProjectCrud', null, this.props.currentUser.id, this.props.currentCompany.id, this.state.selectedMarketId, 'market_' + this.state.selectedMarketId, projectTypeDescriptor, true);
    // Drive the loading indicator off the fetch promise so the dots stay visible for the
    // entire /project_types request. The datasource otherwise fires a synchronous 'prefetch'
    // callback (with cached data) that would clear the flag before the real request resolves.
    const fetchPromise = this.projectTypesDataSource.current(null, true);
    if (fetchPromise) {
      fetchPromise.finally(() => this.setState({ loadingProjectTypes: false }));
    }
    else {
      this.setState({ loadingProjectTypes: false });
    }
    if(market){
      let project = this.state.project;
      if(project.location){
        if(project){
          project.location = null;
          this.currentLocation = null;
          this.setState({ project, searchLocation: null });
        }
      }
    }
  }

  createMarketOptions() {
    const { markets } = this.state;
    if (!markets) {
      return [];
    }
    const marketOptions = markets.map((market) => {
      return { type: market.id, name: market.code, market: market };
    });
    return marketOptions;
  }

  createLocationOptions() {
    const { marketLocations } = this.state;
    if (!marketLocations || marketLocations.length === 0) {
      return [];
    }
    const locationsList = marketLocations.map(location => {
      let locationOption = { type: location.id, name: location.name, location: location };
      return locationOption;
    });
    return locationsList;
  }

  get emptyLocation() {
    return {
      name: '', guid: '', address: '', city: '', state: '', zip: '', latitude: '', longitude: '', company_id: this.props.currentCompany.id,
      user_id: this.props.currentUser.id, ancestry: '',
    };
  }

  copyItems(itemList) {
    if (itemList) {
      let newItemList = [];
      for (let i = 0; i < itemList.length; i++) {
        let item = Object.assign({}, itemList[i]);
        newItemList.push(item);
      }
      return newItemList;
    }
    else {
      return null;
    }
  }

  handleValueChanged(e) {
    let customSetting = Object.assign({}, this.state.customSetting);
    const dataId = e.target.getAttribute('data-id');
    switch (dataId) {
    case 'text-value-field':
      customSetting.text_value = e.target.value;
      break;
    case 'decimal-value-field':
      customSetting.float_value = parseFloat(e.target.value);
      break;
    case 'integer-value-field':
      customSetting.integer_value = isNaN(parseInt(e.target.value, 10)) ? '' : parseInt(e.target.value, 10);
      break;
    case 'units-value-field':
      customSetting.units = e.target.value;
      break;
    case 'maximum-value-field':
      customSetting.max_value = isNaN(parseInt(e.target.value, 10)) ? '' : parseInt(e.target.value, 10);
      break;
    case 'minimum-value-field':
      customSetting.min_value = isNaN(parseInt(e.target.value, 10)) ? '' : parseInt(e.target.value, 10);
      break;
    case 'setting-label':
      customSetting.setting_label = e.target.value;
      break;
    case 'setting-notes':
      customSetting.notes = e.target.value;
      break;
    case 'selected-value-field':
      const selected_values = e.target.value.split(';');
      const preJsonArray = [];
      for (var i = 0; i < selected_values.length; i++) {
        preJsonArray.push({ name: selected_values[i] });
      }
      customSetting.selection_value = JSON.stringify(preJsonArray);
      break;
    default:
      break;
    }
    this.setState({ customSetting: customSetting });
  }

  createTextEditor() {
  }

  createDecimalEditor() {
    const editor = <div className="entry-field">
      <div className="label">UNITS</div>
      <Input className="field input-field" value={this.state.customSetting.units || ''} placeholder="Units (feet, degrees, etc)" data-id="units-value-field" onChange={this.handleValueChanged} />
    </div>;
    return editor;
  }

  handleDueDateSelection(date) {
    this.handleProjectFieldChange('due_date', date);
  }

  handleProjectedStartDateSelection(date) {
    this.handleProjectFieldChange('projected_start_date', date);
  }
  
  createIntegerEditor() {
    const editor = <div>
      <div className="entry-field">
        <div className="label">UNITS</div>
        <Input className="field input-field" value={this.state.customSetting.units || ''} placeholder="Units (feet, degrees, etc)" data-id="units-value-field" onChange={this.handleValueChanged} />
      </div>
      <div className="double-entry-field">
        <div className="half-field">
          <div className="label">MIN VALUE</div>
          <Input className="field input-field" value={this.state.customSetting.min_value || ''} placeholder="Enter a Number" data-id="minimum-value-field" onChange={this.handleValueChanged} />
        </div>
        <div className="half-field">
          <div className="label">MAX VALUE</div>
          <Input className="field input-field" value={this.state.customSetting.max_value || ''} placeholder="Enter a Number" data-id="maximum-value-field" onChange={this.handleValueChanged} />
        </div>
      </div>
    </div>;
    return editor;
  }

  createSelectionEditor() {

    const optionsParsed = this.state.customSetting.selection_value ? JSON.parse(this.state.customSetting.selection_value) : [];

    let optionString = '';
    optionsParsed.map(option => {
      optionString += option.name + ';';
      return option.name;
    });
    optionString = optionString.slice(0, optionString.length - 1);

    return (
      <div className="entry-field selection-options">
        <div className="label">LIST SELECTION OPTIONS, SEPARATED BY A SEMI-COLON</div>
        <Textarea className="textarea-input-field selection-options field" value={optionString} placeholder="Enter Options" data-id="selected-value-field" onChange={this.handleValueChanged} />
      </div>
    );
  }

  createSettingEditor(selectedOption) {
    let settingEditor = null;

    switch (parseInt(selectedOption.type, 10)) {
    case 1:
      settingEditor = this.createTextEditor();
      break;
    case 2:
      settingEditor = this.createDecimalEditor();
      break;
    case 3:
      settingEditor = this.createIntegerEditor();
      break;
    case 4:
      break;
    case 5:
      settingEditor = this.createSelectionEditor();
      break;
    default:
      break;
    }

    return settingEditor;
  }

  handleSelectUser(user) {
    if (this.state.displayEditMember && this.state.selectedUser && user.id === this.state.selectedUser.id) {
      this.setState({ displayEditMember: false });
    }
    else {
      const userElement = document.getElementById('user-avatar-project-' + user.id);
      let x = 0;
      let y = 0;
      if (userElement) {
        const rect = userElement.getBoundingClientRect();
        let parent = document.getElementById('project-crud-header');
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          x = rect.left - parentRect.left - 88;
          y = (rect.top - parentRect.top) + rect.height + 30;
        }
      }
      this.setState({ closeProjectMemberPopup: true, displayEditMember: true, xPos: x, yPos: y, selectedUser: user });
    }
  }

  createMemberArray() {
    const { project } = this.state;
    if (project.users) {
      this.users = project.users;
      return project.users.map(user => {
        const selected = this.state.selectedUser && user && user.id === this.state.selectedUser.id;
        return <UserAvatar id={'user-avatar-project-' + user.id} key={'user-avatar-project-' + user.id} user={user} selected={selected}
          handleSelected={this.handleSelectUser} handleMenuSelection={this.handleMemberMenuSelection} />;
      });
    }
    return null;
  }

  get emptyCustomSetting() {
    return {
      project_id: this.state.project ? this.state.project.id : 0,
      notes: '',
      setting_label: '',
      setting_type: 1,
      text_value: '',
      float_value: '',
      integer_value: '',
      boolean_value: '',
      value_instance_guid: '',
      field_required: '',
      units: '',
      min_value: '',
      max_value: '',
      weather_value: '',
      selection_value: '',
    };
  }

  handleCancelCustomSetting() {
    let { project } = this.state;
    if (project) {
      const original = this.state.project.custom_project_settings ?
        this.state.project.custom_project_settings.filter((cps, index) => {
          return cps.id === this.state.customSetting.id;
        }) : [];

      let savedIndex = null;
      if (project.custom_project_settings) {
        project.custom_project_settings.filter((cps, index) => {
          if (cps.id === this.state.customSetting.id) {
            if (original.length > 0) {
              project.custom_project_settings[index] = original[0];
            }
            else {
              savedIndex = index;
            }
            return true;
          }
          else {
            return false;
          }
        });
      }

      if (savedIndex) {
        project.custom_project_settings.splice(savedIndex, 1);
      }
    }
    this.setState({
      customSetting: this.emptyCustomSetting, customFieldType: null,
      editingCustomField: false, project,
    });
  }

  handleAddCustomSetting() {
    if(this.state.customSetting.setting_label){

      const { customSetting } = this.state;
  
      let { project } = this.state;
  
      if (!project.custom_project_settings) {
        project.custom_project_settings = [];
      }
      let id = -1;
      project.custom_project_settings.forEach(setting => { id = setting.id <= id ? setting.id - 1 : id; });
      customSetting.id = id;
      
      customSetting.toBeAdded = true;
      project.custom_project_settings.push(customSetting);
      this.setState({ projectHasBeenEdited: true });
      this.props.dataModel.dataChanged = true;
      this.setState({ project, customSetting: this.emptyCustomSetting, customFieldType: null, editingCustomField: false });
    }
  }

  handleAddMember() {
    if (this.state.displayAddMember) {
      this.setState({ closeProjectMemberPopup: true });
    }
    else {
      const userElement = document.getElementById('add-member-button');
      let x = 0;
      let y = 0;
      if (userElement) {
        const rect = userElement.getBoundingClientRect();
        let parent = document.getElementById('project-crud-header');
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          x = rect.left - parentRect.left - 168;
          y = rect.top - parentRect.top + 53;
        }
      }
      this.setState({ closeProjectMemberPopup: false, displayAddMember: true, xPos: x, yPos: y, displayEditMember: false });
    }
  }

  handleAddUsersClose() {
    this.setState({ displayAddMember: false, displayEditMember: false });
  }

  handleAddUsers(updatedProject) {
    const { project } = this.state;
    // make sure our copy of the project has these users
    for (let user of updatedProject.users) {
      const foundUser = project.users ? project.users.find((existingUser) => user.id === existingUser.id) : null;
      if (!foundUser) {
        project.users.push(user);
      }
    }
    this.setState({ project });
  }

  handleProjectFieldChange(type, value, testId) {
    this.setState({ projectHasBeenEdited: true });
    let { project } = this.state;
    if (type === 'customers') {
      const id1 = project[type] && project[type].length > 0 ? project[type][0].id : null;
      const id2 = value ? value.id : null;
      if (id1 === id2 || (id1 && !id2)) {
        // de-select if same option is clicked
        if (project.customers && project.customers.length > 0) {
          project.customers[0].id = null;
        }
      }
      else {
        project.customers = value ? [{ id: value.id, name: value.name, project_id: project.id }] : [];
      }
    }
    else if (type === 'project_template') {
      this.new_project_template = value;
      if (!project.config) {
        project.config = {};
      }
      if (value.config && value.config.duration) {
        project.config.duration = true;
      }
      else {
        project.config.duration = false;
      }
    }
    else if (type === 'project_type') {
      this.new_project_type = value;
    }
    else if (type === 'config') {
      project.config = _.merge(project.config, value);
    }
    else if (type === 'projected_start_date') {
      const date = moment(value);
      const s = date.toISOString();
      project.projected_start_date = s;
    }
    else {
      if (testId) {
        const id1 = project[type] ? project[type].id : null;
        const id2 = value.id;
        if (id1 === id2) {
          // de-select if same option is clicked
          if (type === 'project_type') {
            project.project_type = null;
            project.project_type_id = null;
            project.project_template = null;
            project.project_template_id = null;
            this.setState({ project });
          }
          return; // no change
        }
      }
      else if (project[type] === value) {
        return;  // no change
      }
      project[type] = value;

      if (type === 'project_manager') {
        this.new_project_manager = value;
        if (value === null) {
          project.project_manager_id = null;
        }
        else {
          project.project_manager_id = value.id;
        }
      }
      else if (type === 'project_type') {
        project.project_template = null;
      }
      else if (type === 'market') {
        project.market_id = value ? value.id : null;
      }
    }
    this.props.dataModel.dataChanged = true;
    this.setState({ project });
  }

  handleNameChange(e) {
    this.handleProjectFieldChange('name', e.target.value);
  }

  handleGuidChange(e) {
    this.handleProjectFieldChange('guid', e.target.value);
  }

  handleContractIdChange(e) {
    this.handleProjectFieldChange('contract_id', e.target.value);
  }

  handleStartDateSelection(d) {
    this.handleProjectFieldChange('start_date', d);
  }

  handleProjectTypeRetrieval(projectType) {
    this.handleProjectFieldChange('project_type', projectType, true);
  }

  async handleProjectTypeSelection(type, option) {
    const selectedTemplateName = this.new_project_template && this.new_project_template.name;
    if (option) {
      if (this.projectTypeDataSource) {
        this.projectTypeDataSource.release();
        this.projectTypeDataSource = null;
      }
      this.projectTypeDataSource = new DataSource('ProjectType', option.project_type.id, project_type_root, this.handleProjectTypeRetrieval);
      this.projectTypeDataSource.get();
      const projectTemplate = option.project_type.project_templates[0];
      if(projectTemplate.name !== selectedTemplateName){
        let project = this.state.project;
        this.new_project_template = null;
        if(project){
          project.project_template = null;
          this.setState({ project });
        }
      }
    }
  }

  handleProjectTemplateSelection(type, option) {
    if (option) {
      this.handleProjectFieldChange('project_template', option.project_template, true);
      let project = this.state.project;
      if(!project.project_template){
        if(project){
          project.project_template = option.project_template;
          this.setState({ project });
        }
      }
    }
  }

  changeProjectTemplateDialog(message, projectTemplate, customHeight) {
    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.cancel.toUpperCase(),
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300,
      height: customHeight || 184,
      handleOwnerOk: () => {
        this.handleValidProjectSave();
        this.analyticsLogger.logProjectTemplateEvent(projectTemplate, 'ProjectTemplateManually');
      },
      handleOwnerCancel: () => {
        this.setState({ project: this.state.project, isSaving: false });
      },
    });
  }

  handleKeyboardLocationSearch(e) {
    if (e.keyCode === 27) {
      this.setState({ searchLocation: null });
    }
    else if (e.keyCode === 8 || e.keyCode === 46) {
      if (!this.state.searchLocation || this.state.searchLocation.id) {
        this.clearSearch = true;
        this.setState({ searchLocation: null });
      }
    }
  }

  onCalendarClose(){
    const elementToChangeFocus = document.getElementById('projectNameInput');
    if (elementToChangeFocus) {
      elementToChangeFocus.focus();
    }
  }

  handleLocationRetrieval(foundLocation) {
    let { project } = this.state;
    project.location = foundLocation;
    this.props.dataModel.dataChanged = true;
    this.setState({
      project,
      searchLocation: null,
    });
  }

  handleLocationSelection(type, option) {
    let { project } = this.state;
    if (option) {
      if (this.locationDataSource) {
        this.locationDataSource.release();
        this.locationDataSource = null;
      }
      this.setState({ projectHasBeenEdited: true });
      project.location = option.location;
      this.props.dataModel.dataChanged = true;
      this.setState({
        project,
        searchLocation: null,
      });
      //handling for location contacts here
      if ((!option.location.latitude && !option.location.longitude) ||
        !option.location.city || !option.location.market) {
        this.locationDataSource = new DataSource('Location', option.location.id, location_root, this.handleLocationRetrieval);
        this.locationDataSource.get();
      }
    }
  }

  handleNotesChange(e) {
    this.handleProjectFieldChange('notes', e.target.value);
  }

  isRequiredFieldsAreEmpty(){
    const { project, selectedMarketId } = this.state;
  
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    const isProjectNew = params.get('isProjectNew');  

    if(isProjectNew){
      if(!selectedMarketId){
        dataModel.requiredDataNotAvailable = true;
      }
      else if(!project){
        dataModel.requiredDataNotAvailable = true;
      }
      else if(!project.location){
        dataModel.requiredDataNotAvailable = true;
      }
      else if(!project.location.name){
        dataModel.requiredDataNotAvailable = true;
      }
      else if(!project.location.guid){
        dataModel.requiredDataNotAvailable = true;
      }
      else if(!project.name){
        dataModel.requiredDataNotAvailable = true;
      }
      else{
        dataModel.requiredDataNotAvailable = false;
      }
    }
  }

  deleteNewProject(){
    dataModel.projectsDAO.deleteProject(this.props.id).then(response => {
      this.props.history.push('/projects/summary');
      dataModel.requiredDataNotAvailable = false;
      dataModel.dataChanged = false;
    });
  }

  handleCancelProjectEdit() {
    const message = this.textMap.queryDataChanged;
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    const isProjectNew = params.get('isProjectNew');  

    if(dataModel.requiredDataNotAvailable || isProjectNew){
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'If you leave this page, the new project you are creating will be deleted. If you wish to continue, click Yes. If you do not wish to continue, click No and provide the required fields on the page to save the project.',
        cancelButtonText: this.textMap.no.toUpperCase(),
        okButtonText: this.textMap.yes.toUpperCase(),
        width: 420,
        height: 200,
        handleOwnerOk: () => {
          this.deleteNewProject();
        },
      });
    }
    else if(dataModel.dataChanged){
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: message,
        cancelButtonText: this.textMap.no.toUpperCase(),
        okButtonText: this.textMap.yes.toUpperCase(),
        width: 300,
        height: 180,
        handleOwnerOk: () => {
          dataModel.dataChanged = false;
          if(dataModel.requiredDataNotAvailable || isProjectNew){
            this.handleCancelProjectEdit();
          }
          else{
            this.props.history.push('/projects/' + this.state.project.id);
          }
        },
      });
    }
    else {
      this.props.history.push('/projects/' + this.state.project.id);
    }
  }

  handleValidation(string) {
    let pass = false;
    if (string && string.length > 0 && string.trim() != '') {
      pass = true;
    }
    return pass;
  }

  handleSaveProject() {
    const { project, isSaving } = this.state;
    
    if (project && !isSaving) {
      this.setState({ isSaving: true });
      let projNameValid = this.handleValidation(project.name);
    
      if (!project.market && !project.location) {
        this.props.dataModel.displayInfoErrorMessage('A market an location must be assigned.', 4000, 2);
        this.setState({ isSaving: false });
      }
      else if (!project.market) {
        this.props.dataModel.displayInfoErrorMessage('A market must be assigned.', 4000, 2);
        this.setState({ isSaving: false });
      }
      else if (!project.location) {
        this.props.dataModel.displayInfoErrorMessage('A location must be assigned.', 4000, 2);
        this.setState({ isSaving: false });
      }
      else if (this.hasOwnProperty('new_project_type') && !this.new_project_type) {
        this.props.dataModel.displayInfoErrorMessage('A project type must be assigned.', 4000, 2);
        this.setState({ isSaving: false });
      }
      else if (this.hasOwnProperty('new_project_template') && !this.new_project_template) {
        this.props.dataModel.displayInfoErrorMessage('A project template must be assigned.', 4000, 2);
        this.setState({ isSaving: false });
      }
      else if (!this.hasOwnProperty('new_project_type') && !project.project_type) {
        this.props.dataModel.displayInfoErrorMessage('A project type must be assigned.', 4000, 2);
        this.setState({ isSaving: false });
      }
      else if (!this.hasOwnProperty('new_project_template') && !project.project_template) {
        this.props.dataModel.displayInfoErrorMessage('A project template must be assigned.', 4000, 2);
        this.setState({ isSaving: false });
      }
      else if (projNameValid) {
        if (this.new_project_template && project.project_template_id && this.new_project_template.id != project.project_template_id) {
          const message = `You are changing ${project.name} to the latest version of ${project.project_template.name}. This may change the project's builds, tasks, and completion steps. Are you sure you want to make this change?`;
          this.changeProjectTemplateDialog(message, project.project_template, 210);
        }
        else if (this.currentProjectTemplate) {
          const message = `Your project ${project.name} is currently associated to a project template. This change will remove all builds, tasks and completion steps from the project. Are you sure you want to make this change?`;
          this.changeProjectTemplateDialog(message, this.currentProjectTemplate, 210);
        } else {
          this.handleValidProjectSave();
        }
      }
      else {
        this.props.dataModel.displayInfoErrorMessage(`A ${this.textMap.project} name must be assigned.`, 4000, 2);
        this.setState({ isSaving: false });
      }
    }
  }

  handleFinishProjectUpdate(project) {
    if (!this._isMounted) return;
    this.setState({ projectHasBeenEdited: false });

    let updateRequest;
    this.props.dataModel.dataChanged = false;
    dataModel.requiredDataNotAvailable = false;
    const projectUsersAddRemove = [];
    project.project_users.forEach(projectUser => {
      if (projectUser.assignment_type === 'notify' && (projectUser.toBeAdded || projectUser.toBeDeleted)) {
        projectUsersAddRemove.push({ ...projectUser });
        delete projectUser.toBeAdded;
        delete projectUser.toBeDeleted;
      }
    });

    // ********** Project Manager changed ******************
    if (this.new_project_manager) {
      updateRequest = dataModel.projectsDAO.setProjectManager(project, this.new_project_manager, { recordDescriptor: project_for_edit });
    }
    else if (this.new_project_manager === null) {
      updateRequest = dataModel.projectsDAO.removeProjectManager(project, this.state.project.project_manager, { recordDescriptor: project_for_edit });
    }

    // ********** Custom project settings changed ******************
    if (project.custom_project_settings) {
      for (let customSetting of project.custom_project_settings) {
        if (customSetting.toBeAdded) {
          customSetting.project_id = project.id;
          updateRequest = dataModel.customProjectSettingsDAO.addCustomSetting(customSetting, project);
        }
        else if (customSetting.toBeDeleted) {
          updateRequest = dataModel.customProjectSettingsDAO.deleteCustomSetting(customSetting, project);
        }
        else if (customSetting.toBeUpdated) {
          updateRequest = dataModel.customProjectSettingsDAO.updateCustomSetting(customSetting, project);
        }
      }
    }
    // ********** Project members changed ******************
    if (projectUsersAddRemove.length > 0) {
      for (let projectUser of projectUsersAddRemove) {
        updateRequest = dataModel.projectsDAO.addOrRemoveNotifyUser(project, projectUser, projectUser.toBeDeleted, { recordDescriptor: project_for_edit });
      }

    }

    if (updateRequest) {
      updateRequest.then(() => {
        if (this._isMounted && this.props.handleSaveProject) {
          this.props.handleSaveProject(project.id);
        }
      });
    }
    this.props.history.push('/projects/' + this.state.project.id);
    if (this._isMounted) {
      this.setState({ project: null, isSaving: false });
    }
  }

  async handleValidProjectSave() {
    this.props.dataModel.dataChanged = false;

    let project = _.cloneDeep(this.state.project);
    const projectTemplateId = project.project_template_id;
    const updateProjectTemplate = this.new_project_template;
    // check for new template
    if (updateProjectTemplate && updateProjectTemplate.id != project.project_template_id) {
      // ensure project references new type/template (so that update detects
      // a change... we may need to remove the template handling from update
      // and force the client code to make its own separate call when necessary)
      project.project_type = this.new_project_type;
      project.project_template = updateProjectTemplate;
      project.project_template_id = updateProjectTemplate.id;
    }
    else if (this.currentProjectTemplate) {
      // currently associated to a template but no longer...
      // use a fake project template with an id that will indicate
      // to the backend that the existing template association should
      // be removed
      project.project_type = { id: -1 };
      project.project_template = { id: -1 };
    }

    if (this.state.searchLocation) {
      project.location = this.state.searchLocation;
    }

    // ********* Project info changed THIS HAS TO FINISH BEFORE THE OTHERS IN THE CASE OF PROJECT TEMPLATE CHANGE **********************
    if (this.state.projectHasBeenEdited) {
      project.project_users.forEach(projectUser => {
        if (projectUser.assignment_type === 'notify' && (projectUser.toBeAdded || projectUser.toBeDeleted)) {
          delete projectUser.toBeAdded;
          delete projectUser.toBeDeleted;
        }
      });

      if (updateProjectTemplate && updateProjectTemplate.id != projectTemplateId) {
        this.setState({ isSaving: true });
        projectsService.migrateProjectProjectTemplate(project, updateProjectTemplate)
          .then((response) => {
            if (!this._isMounted) return;
            if (response) {
              this.setState({ project }, () => {
                if (!this._isMounted) return;
                this.projectDataSource.update(project, 'update');
                this.handleFinishProjectUpdate(project);
              });
            } else {
              this.setState({ isSaving: false });
            }
          })
          .catch(() => {
            if (!this._isMounted) return;
            this.setState({ isSaving: false });
            if (dataModel && typeof dataModel.displayHTTPError === 'function') {
              dataModel.displayHTTPError('Updating project template', 'Request failed', false);
            }
          });
      }
      else{
        this.setState({ project }, () => {
          this.projectDataSource.update(project, 'update');
          this.handleFinishProjectUpdate(project);
        });
      }    
    }

  }

  updateSettingInProject(customSetting) {
    let { project } = this.state;
    const matched = project.custom_project_settings ?
      project.custom_project_settings.filter((cps, index) => {
        if (cps.id === customSetting.id) {
          project.custom_project_settings[index] = customSetting;
          return true;
        }
        else {
          return false;
        }
      }) : [];

    this.props.dataModel.dataChanged = true;
    this.setState({ project: project, customSetting: customSetting });
    return matched.length > 0;
  }

  handleCustomFieldTypeSelection(type, option) {
    if (option) {
      const { customSetting } = this.state;
      const editedCustomSetting = Object.assign({}, customSetting, { setting_type: parseInt(type, 10) });
      this.setState({ customFieldType: option, customSetting: editedCustomSetting });
    }
  }

  handleSettingEdit(customSetting) {
    const settingType = customSetting.setting_type - 1;
    if (settingType >= 0 && settingType < this.customFieldTypes.length) {
      const customFieldType = this.customFieldTypes[settingType];
      this.setState({ customSetting: customSetting, customFieldType: customFieldType, editingCustomField: true });
    }
  }

  handleSettingUpdate() {
    let { customSetting } = this.state;
    if (customSetting) {
      customSetting.toBeUpdated = true;
      this.updateSettingInProject(customSetting);
      this.props.dataModel.dataChanged = true;
      this.setState({ customSetting: this.emptyCustomSetting, editingCustomField: false, customFieldType: null, projectHasBeenEdited: true });
    }
  }

  doDeleteProjectSetting() {
    if (this.customSetting && this.customSetting.id && this.customSetting.id > 0) {
      this.customSetting.toBeDeleted = true;
      this.updateSettingInProject(this.customSetting);
    }
    else {
      let deleteIndex = -1;
      let { project } = this.state;
      if (project && project.custom_project_settings) {
        deleteIndex = project.custom_project_settings.findIndex(setting => { return setting.id === this.customSetting.id; });
      }
      if (deleteIndex >= 0) {
        project.custom_project_settings.splice(deleteIndex, 1);
        this.setState({ project: project });
      }
    }
    this.customSetting = null;
    this.props.dataModel.dataChanged = true;
    this.setState({ customSetting: this.emptyCustomSetting, customFieldType: null, editingCustomField: false });
  }

  preventKeyPress(event) {
    event.preventDefault();
  }

  queryDeleteSetting() {

    document.addEventListener('keydown', this.preventKeyPress);
    const message = this.textMap.projectSettingArchiveQuestion;
    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.no.toUpperCase(),
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300,
      height: 175,
      handleOwnerOk: () => {
        document.removeEventListener('keydown', this.preventKeyPress);
        this.doDeleteProjectSetting();
        this.setState({ projectHasBeenEdited: true });
      },
      handleOwnerCancel: () => {
        document.removeEventListener('keydown', this.preventKeyPress);
        this.customSetting = null;
      },
    });
  }

  handleSettingDelete(customSetting) {
    this.customSetting = customSetting;
    this.queryDeleteSetting();
  }

  handleFieldChanges(field) {
    let { project } = this.state;
    if (!project.custom_project_settings) {
      project.custom_project_settings = [];
      project.custom_project_settings.push(field);
    }
    else {
      for (var i = 0; i < project.custom_project_settings.length; i++) {
        if (project.custom_project_settings[i].id === field.id) {
          project.custom_project_settings[i].toBeUpdated = true;
          switch (project.custom_project_settings[i].setting_type) {
          case 1:
            project.custom_project_settings[i].text_value = field.text_value;
            break;
          case 2:
            project.custom_project_settings[i].float_value = field.float_value;
            break;
          case 3:
            project.custom_project_settings[i].integer_value = field.integer_value;
            break;
          case 4:
            project.custom_project_settings[i].boolean_value = field.boolean_value;
            break;
          default:
            break;
          }
          break;
        }
      }
    }
    this.props.dataModel.dataChanged = true;
    this.setState({ project: project });
  }

  handlePMSelection(type, option) {
    if (option && option.selected) {
      this.handleProjectFieldChange('project_manager', option.user, true);
    }
    else {
      this.handleProjectFieldChange('project_manager', null, false);
    }
  }

  handleCustomerSelection(type, option) {
    if (option && !option.selected) {
      this.handleProjectFieldChange('customers', { id: option.type });
    }
    else {
      this.handleProjectFieldChange('customers', null);
    }
  }

  handleProjectGroupSelection(type, option) {
    if (option && !option.selected) {
      if(option.type === 'create'){
        this.setState({ isCreateNewPGPopup: true });
      }
      else{ 
        this.setState({ selectedGroup: option });
        this.handleProjectFieldChange('project_group', { id: option.id });
      }
    }
    else {
      this.setState({ selectedGroup: null });
      this.handleProjectFieldChange('project_group', null);
      this.handleProjectFieldChange('project_group_id', null);
    }
  }

  handleSearchGuid(e) {
    const { searchLocation } = this.state;
    const { project } = this.state;

    let value = e.target.value ? e.target.value : '';
    let editSearchLocation = searchLocation ? searchLocation : {
      name: '', guid: '', address: '', city: '', state: '', zip: '', latitude: '', longitude: '', company_id: this.props.currentCompany.id,
      user_id: this.props.currentUser.id, ancestry: '',
    };
    if (this.clearSearch) {
      this.clearSearch = false;
      editSearchLocation = {
        name: '', guid: '', address: '', city: '', state: '', zip: '', latitude: '', longitude: '', company_id: this.props.currentCompany.id,
        user_id: this.props.currentUser.id, ancestry: '',
      };
      editSearchLocation.guid = this.lastBeforeMatch ? this.lastBeforeMatch : '';
    }
    else {
      const self = this;
      editSearchLocation.guid = value;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(async () => {

        if (this.state.marketLocations) {
          let marketLocations = this.state.marketLocations.filter(location => {
            // if the project has members, only locations from the current market are valid
            if (!location.market_id) return false;
            else return (!project.users || !project.users.length || !project.location || (project.users.length && project.location.market && location.market_id === project.location.market.id));
          });
          marketLocations = marketLocations && value ? marketLocations.filter(location => {
            return location.guid && location.guid.toLowerCase().indexOf(value.toLowerCase()) >= 0;
          }) : [];
          marketLocations.sort((a1, a2) => { return a1.guid.length < a2.guid.length ? -1 : a1.guid.length > a2.guid.length ? 1 : 0; });
          let subLocations = marketLocations.filter(loc => {
            return loc.guid.toLowerCase().indexOf(marketLocations[0].guid.toLowerCase()) === 0;
          });
          if (marketLocations.length > 0 && subLocations.length === marketLocations.length) {
            editSearchLocation = Object.assign({}, marketLocations[0]);
            project.location = editSearchLocation;
            if (project.location && project.location.market) {
              this.getProjectManagers(project.location.market);
            }
  
            self.setState({ projectHasBeenEdited: true });
            if (marketLocations.length === 1) {
              self.lastBeforeMatch = '';
            }
          } else {
            locationsService.search('', value).then(response => {
              editSearchLocation = Object.assign({}, response[0]);
              project.location = editSearchLocation;
              if (project.location && project.location.market) {
                this.getProjectManagers(project.location.market);
              }
              self.setState({ projectHasBeenEdited: true });
              if (marketLocations.length === 1) {
                self.lastBeforeMatch = '';
              }
              this.currentLocation = editSearchLocation;
              self.setState({ searchLocation: editSearchLocation, project: project });
            })
            .catch(error=>{
              editSearchLocation = { name: '', guid: value, address: '', city: '', state: '', zip: '', latitude: '', longitude: '', company_id: self.props.currentCompany.id, user_id: self.props.currentUser.id, ancestry: '' };
              if (editSearchLocation.id) {
                self.lastBeforeMatch = '';
              } else {
                self.lastBeforeMatch = value;
              }
            });
          }
          this.currentLocation = editSearchLocation;
          self.setState({ searchLocation: editSearchLocation, project: project });
        }
      }, 500);
    }
    this.setState({ searchLocation: editSearchLocation, project: project });
  }

  handleRemoveUser(removeUser) {
    const { project } = this.state;
    if (project.users) {
      const userToRemove = this.state.project.project_users.find((pu, index) => {
        return removeUser.id === pu.user_id;
      });
      if (userToRemove) {
        userToRemove.toBeDeleted = true;
        dataModel.projectsDAO.removeUserFromProject(userToRemove, project);
      }
    }
    this.setState({ displayEditMember: false });
  }

  handleReplaceUser(user) {
    if (this.state.selectedUser && this.state.selectedUser.id === user.id) {
      this.props.dataModel.displayWarnErrorMessage('You cannot select the same user...', 4000, 2);
    }
    else {
      const oldUser = this.state.project.users ? this.state.project.users.find(user => {
        return user.id === this.state.selectedUser.id;
      }) : null;

      if (oldUser) {
        this.analyticsLogger.logProjectMemberReplace();
        dataModel.projectsDAO.replaceProjectMember(this.state.project, oldUser, user);
      }
    }
    this.setState({ displayEditMember: false });
  }

  createNotifyMemberArray(userList, type) {
    if (userList) {
      return userList.map(user => {
        return <UserAvatar id={'user-avatar-task-crud' + type + user.id} key={'user-avatar-task-crud' + type + user.id} user={user} small={true} />;
      });
    }
    else {
      return null;
    }
  }

  handleCloseComboBox(){
    this.locationsDataSource.current();
  }

  handleSearchLocation(searchString){
    const { project } = this.state;
    if(searchString && searchString.length > 2) {
      this.setState({ loadingLocations: true });
      const lowerSearchString = searchString.toLowerCase();
      const foundLocations = [];
      locationsService.search(searchString, '').then(response => {
        response.forEach(location => {
          if(location.name.toLowerCase().includes(lowerSearchString) && location.market.id === project.market.id){
            foundLocations.push(location);
          }
        });
        if(foundLocations.length > 0){
          this.setState({ marketLocations: foundLocations, loadingLocations: false });
        }
        else{
          this.setState({ marketLocations: [{}], loadingLocations: false });
        }
      })
      .catch(error=>{
        this.setState({ marketLocations: [{}], loadingLocations: false });
      });
      
    }
    else  if(searchString===''){
      this.locationsDataSource.current().then(()=>{
        this.setState({ loadingLocations: false });
      });
      
    }
  }
  makeUserAssignments(type, multipleSelections, selectedOption) {
    let { project } = this.state;
    let project_user = null;
    if (project.project_users) {
      project_user = project.project_users.find(puser => {
        return puser.user_id === selectedOption.user.id || (puser.user && puser.user.id === selectedOption.user.id);
      });
      if (project_user) {
        if (selectedOption.selected) {
          // See if there was already a user of that type

          project_user.assignment_type = type;
          project_user.toBeAdded = true;
        }
        else {
          project_user.toBeDeleted = true;
        }
        this.setState({ project: project, projectHasBeenEdited: true });
        this.props.dataModel.dataChanged = true;
      }
    }
  }

  handleNotifyMultipleSelection(multipleSelections, selectedOption) {
    this.makeUserAssignments('notify', multipleSelections, selectedOption);
  }

  getProjectTypesForMarket(marketId) {
    let projectTypes = [];
    if (this.state.project_types && this.state.project_types.reduce) {
      projectTypes = this.state.project_types.reduce((filtered, project_type) => {
        if (project_type.project_templates && project_type.project_templates.length > 0) {
          const belongsToMarket = project_type.project_templates.find(project_template => {
            if (project_template.markets) {
              return project_template.markets.find(projectTemplateMarket => {
                return projectTemplateMarket.id === marketId;
              });
            }
            return false;
          });
          if (belongsToMarket) {
            filtered.push(project_type);
          }
        }
        return filtered;
      }, []);
    }
    return projectTypes;
  }

  getInvalidProjectContactIdsForMarket() {
    // See if we will be clearing any location contacts
    const marketUserIds = new Set();
    const invalidProjectContactIds = [];
    if (this.state.allMarketUsers) {
      for (let user of this.state.allMarketUsers) {
        marketUserIds.add(user.id);
      }
    }
    if (this.state.project.project_contacts) {
      for (let projectContact of this.state.project.project_contacts) {
        if(!marketUserIds.has(projectContact.user_id)) {
          // warn user if changing the market will clear one or more assigned contacts
          // note: user_id corresponds to the id of the User (same as market), but id corresponds to the ProjectContact id
          invalidProjectContactIds.push(projectContact.id);
        }
      }
    }
    return invalidProjectContactIds;
  }

  /** Delete user from location-users list */
  handleDeleteProjectContact(projectContactId) {
    dataModel.projectsDAO.deleteProjectContact(projectContactId, this.state.project.id).then(() => {
      const editLocationCopy = Object.assign({}, this.state.project);
      const userToDeleteIndex = editLocationCopy.project_contacts.findIndex((projectContact) => {
        return projectContact.id === projectContactId;
      });
      editLocationCopy.project_contacts.splice(userToDeleteIndex, 1);
      //update state
      this.setState({ project: editLocationCopy });
    });
  }

  /** Add or update user in location-users list */
  handleSaveProjectContact(projectContactId, editedContact) {
    console.log('project contact id', projectContactId, editedContact);
    const newUser = projectContactId ? false : true;
    if (newUser) {
      editedContact.project_id = this.state.project.id;
      dataModel.projectsDAO.createProjectContact(editedContact).then((createdProjectContact) =>{
        if (createdProjectContact) {
          let editLocationCopy = Object.assign({}, this.state.project);
          if (!editLocationCopy.project_contacts) {
            editLocationCopy.project_contacts = [];
          }
          editLocationCopy.project_contacts.push(createdProjectContact);
          this.setState({ project: editLocationCopy });
        }
      });
    }
    else {
      dataModel.projectsDAO.updateProjectContact(editedContact).then((updatedProjectContact) =>{
        const editLocationCopy = Object.assign({}, this.state.project);
        if (updatedProjectContact) {
          if (!editLocationCopy.project_contacts) {
            editLocationCopy.project_contacts = [];
            editLocationCopy.project_contacts.push(updatedProjectContact);
          }
          else {
            editLocationCopy.project_contacts = editLocationCopy.project_contacts.map(locUser => {
              if (locUser.id === updatedProjectContact.id) {
                return updatedProjectContact;
              }
              else{
                return locUser;
              }
            });
            this.setState({ project: editLocationCopy });
          }
        }
      });
      
    }
  }
  getUnassignedMarketUsers(marketUsers) {
    const assignedUserIds = new Set();
    if (this.state.project.project_contacts) {
      for (let projectContact of this.state.project.project_contacts) {
        if (projectContact.user) {
          assignedUserIds.add(projectContact.user.id);
        }
        else if (projectContact.firstName) {
          assignedUserIds.add(projectContact.user.id);
        }
      }
    }
    if (marketUsers) {
      return marketUsers.filter((marketUser) => {
        return (!assignedUserIds.has(marketUser.id));
      });
    }
    return [];
  }
  handleClosePopup(){
    this.setState({ isCreateNewPGPopup: false });
  }

  handleSaveProjectGroup(name){
    const _this = this;
    ProjectGroupService.createProjectGroup(_this.props.currentCompany.id, name).then(res=>{
      this.handleProjectGroupsRetrieval();
      let newGroup = {
        type: res.data.type,
        id: res.data.id,
        name: res.data.attributes.name,
      };
      _this.handleProjectGroupSelection(newGroup.type, newGroup);
    });
  }

  renderProjectContacts() {
    let contactList = [];
    const unassignedMarketUsers = this.getUnassignedMarketUsers(this.state.allMarketUsers);
    const projectContacts = this.state.project.project_contacts || this.state.location.project_contacts;
    if(projectContacts && projectContacts.length) {
      for (let projectContact of projectContacts) {
        // add selected to options list
        const contactMarketUsers = Object.assign([], unassignedMarketUsers);
        contactMarketUsers.push(projectContact.user);
        
        contactList.push(
        <ProjectContact 
            key={'project-contact-'+projectContact.id}
            contact={projectContact} 
            contactMarketUsers={contactMarketUsers} 
            handleDeleteProjectContact={this.handleDeleteProjectContact} 
            handleSaveProjectContact={this.handleSaveProjectContact} />
        );
      }
    }
    if ((!projectContacts || projectContacts.length < 2) && unassignedMarketUsers) {
      //maximum of 2 key contacts
      const randomId = Math.floor(Math.random() * 1000);
      const newContact = (
        <ProjectContact
          key={'location-contact-new' + randomId}
          contactMarketUsers={unassignedMarketUsers} 
          handleDeleteProjectContact={this.handleDeleteProjectContact}
          handleSaveProjectContact={this.handleSaveProjectContact} />
      );
      contactList.push(newContact);
    }

    return (
      <div className="column project-contacts">
        <div className="caption">Project Contacts</div>
        <div className='project-contacts-container'>
          {contactList}
        </div>
      </div>
    );
  }

  handleInfoOpen(assignment) {
    this.setState({ displayedUserInfo: assignment });
  }

  handleInfoClose() {
    this.setState({ displayedUserInfo: null });
  }

  handleDurationToggle(checked) {
    this.handleProjectFieldChange('config', { duration: checked });
  }

  formatDate(date) {
    let formattedDate = null;
    if (date) {
      let dateFormatter = new Date(date);
      let month = dateFormatter.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let day = dateFormatter.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      let year = dateFormatter.getFullYear();
      formattedDate = month + '/' + day + '/' + year;
    }
    return formattedDate;
  }

  handleLocationAdd(options){
    if(this.state.totalLocation > options.length){
      this.setState({ loadingLocations: true });
      this.locationsDataSource.next().then(()=>{
        this.setState({ loadingLocations: false });
      });
    }
  }

  render() {
    let { project, locationsList, isSaving } = this.state;
    if (!project) {
      return null;
    }
    let projectEligibleForUpdate = false;
    //not sure what else should be checked here
    if (project.status === 'not_started') {
      projectEligibleForUpdate = true;
    }
    const { searchLocation, loadingLocations, loadingMarkets, loadingProjectTypes, projectHasBeenEdited } = this.state;

    const users = project.users;

    let localLocation = searchLocation ? searchLocation : (project.location ? project.location : { guid: '' });
    let accent_color = this.props.currentCompany ? this.props.currentCompany.accent_color : '#9b9b9b';
    const memberImages = this.createMemberArray();

    let addMemberPopup = null;
    if (this.state.displayAddMember) {
      addMemberPopup = (
        <SelectProjectMemberPopup
          handlePopupClose={this.handleAddUsersClose}
          requestClose={this.state.closeProjectMemberPopup}
          project={project}
          top={this.state.yPos}
          left={this.state.xPos}
          multiSelect={true}
          type="add"
          skipProjectFetch={true}
          updateProject={this.handleAddUsers}
        />
      );
    }
    else if (this.state.displayEditMember) {
      addMemberPopup = (
        <ReplaceProjectMemberPopup
          key={this.state.selectedUser ? this.state.selectedUser.id : Math.random()}
          replaceMember={this.handleReplaceUser}
          selectedUser={this.state.selectedUser}
          handlePopupClose={this.handleAddUsersClose}
          project={project}
          top={this.state.yPos}
          left={this.state.xPos}
          multiSelect={false}
          type="replace"
        />
      );
    }
    const projectIsFavorite = project.is_favorite;

    let project_type = this.new_project_type ? this.new_project_type : (this.state.project_types && !loadingProjectTypes ? project.project_type : undefined);
    let currentProjectType = project_type ? { type: project_type.id, name: project_type.name, project_type: project_type } : undefined;
    let project_template = this.new_project_template ? this.new_project_template : (this.state.project_types && !loadingProjectTypes ? project.project_template : undefined);

    let project_templatesList = null;
    let project_typesList = null;
    if (this.state.project_types) {
      const projectTypes = this.getProjectTypesForMarket(project.market.id);
      project_typesList = projectTypes.map((projectType) => {
        return { type: projectType.id, name: projectType.name, project_type: projectType };
      });
    }

    let mostRecentProjectTemplates;

    let marketsList = this.createMarketOptions();
    if (project_type && project.market) {
      if (project_type.project_templates) {
        let validProjectTemplates = project_type.project_templates.filter(pt => {
          const hasMarket = pt.markets ? pt.markets.filter(mark => {
            return project.market.id === mark.id;
          }) : [];
          return pt.published_at && hasMarket.length > 0;
        });
        //gets all project tempaltes with the newest version
        mostRecentProjectTemplates = validProjectTemplates.reduce((accu, project_template) => {
          if (!accu[project_template.group_identifier]) {
            accu[project_template.group_identifier] = {
              type: project_template.id,
              name: 'V' + project_template.version + ' | ' + project_template.name,
              version: project_template.version,
              project_template: project_template,
            };
          } else if (project_template.version > accu[project_template.group_identifier].version) {
            accu[project_template.group_identifier] = {
              type: project_template.id,
              name: 'V' + project_template.version + ' | ' + project_template.name,
              version: project_template.version,
              project_template: project_template,
            };
          }
          return accu;
        }, {});

        project_templatesList = Object.values(mostRecentProjectTemplates);
      }
    }

    const currentFieldType = this.state.customFieldType ? this.state.customFieldType : this.customFieldTypes[0];

    const settingEditor = this.createSettingEditor(currentFieldType);

    let address1 = (localLocation.address ? localLocation.address + ' ' : '');
    let address2 = (localLocation.city ? localLocation.city + ', ' : '') + (localLocation.state || '') + ' ' + (localLocation.zip || '');

    let memberSelector = null;
    if (!this.props.currentCompany.admin_company) {
      memberSelector = (
        <div className="member-selection">
          <div className="label">
            {this.textMap.members.toUpperCase()}
          </div>
          <div className="member-container">
            <div className="add-member-button" id="add-member-button" onClick={this.handleAddMember}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div className="member-array">
              {memberImages}
            </div>
          </div>
        </div>
      );
    }

    let dateFormatter = project.created_at ? new Date(project.created_at) : new Date();
    let createDate = dateFormatter ? dateFormatter.toLocaleDateString() : 'No Date Set';
    const dueDate = this.formatDate(project.due_date);
    const projectedStartDate = this.formatDate(project.projected_start_date);
    const actualStartDate = this.formatDate(project.actual_start_date);
      
    let project_typesPicker = null;
    let project_templatesPicker = null;

    //PROJECT TEMPLATES
    //get the current project template
    let currentProjectTemplate = null;

    if (project_templatesList && project_template) {
      const mostRecentProjectTemplate = mostRecentProjectTemplates[project_template.group_identifier];
      currentProjectTemplate = {
        type: project_template.id,
        name: 'V' + project_template.version + ' | ' + project_template.name,
        version: project_template.version,
        project_template: project_template,
      };

      if (mostRecentProjectTemplate && mostRecentProjectTemplate.type != currentProjectTemplate.type) {
        project_templatesList = [currentProjectTemplate, mostRecentProjectTemplate];
      }
    }

/*
    //if statement to determine if project type picker displays (take into account ever project has a root build)
    if (project.builds && project.builds.length > 1) {
      project_typesPicker = <div className="entry-field">
        <div className="label">{this.textMap.projectType.toUpperCase()}</div>
        <div className="field inactive">{project_type ? (project_type.name ? project_type.name :
          project_type.project_type ? project_type.project_type : "") : ""}</div>
      </div>
      //if statement to determine if project_template picker displays
      //show as inactive if project_template is most recent version or project.project_template_id is null
      if ((projectEligibleForUpdate && currentProjectTemplate && !project_templatesList) || !projectEligibleForUpdate) {
        project_templatesPicker = <div className="entry-field">
          <div className="label">{this.textMap.projectTemplate.toUpperCase()}</div>
          <div className="field inactive">{currentProjectTemplate ? currentProjectTemplate.name : ''}</div>
        </div>
      } else if (currentProjectTemplate && project_templatesList) {
        project_templatesPicker = <div className="entry-field">
          <div className="label">{this.textMap.projectTemplate.toUpperCase()}</div>
          <div id="project_templatePickerField" className={"field combo" + (project_templatesList && !project_templatesList.length ? " inactive" : "")}>
            <ComboBox
              id={"project_templatePicker"}
              options={project_templatesList}
              currentOption={currentProjectTemplate}
              hasBorder={false}
              underlined={false}
              width={259}
              small={true}
              height={24}
              displayFontStyle={{ fontSize: "12px" }}
              handleSelection={this.handleProjectTemplateSelection}
              placeHolderText={this.textMap.projectTemplate}
              disabled={!projectEligibleForUpdate}
            />

          </div>
        </div >
      }
    } else {
*/    
    project_typesPicker = <div className="entry-field">
        <div className="label required">{this.textMap.projectType.toUpperCase()}</div>
        <div id="project_typePickerField" className={'field combo' + (!project_typesList || project_typesList.length === 0 ? ' inactive' : '')}>
          <ComboBox
            id={'project_typePicker'}
            options={project_typesList}
            currentOption={currentProjectType}
            hasBorder={false}
            underlined={false}
            width={259}
            small={true}
            height={24}
            displayFontStyle={{ fontSize: '12px' }}
            handleSelection={this.handleProjectTypeSelection}
            placeHolderText={this.textMap.projectType}
            disabled={!projectEligibleForUpdate}
          />
          {loadingProjectTypes && <LoadingDots />}
        </div>
      </div>;
    if (project_type && project.market) {
      project_templatesPicker = <div className="entry-field">
          <div className="label required">{this.textMap.projectTemplate.toUpperCase()}</div>
          <div id="project_templatePickerField" className={'field combo' + (project_templatesList && project_templatesList.length === 0 ? ' inactive' : '')}>
            <ComboBox
              id={'project_templatePicker'}
              options={project_templatesList}
              currentOption={currentProjectTemplate}
              hasBorder={false}
              underlined={false}
              width={259}
              small={true}
              height={24}
              displayFontStyle={{ fontSize: '12px' }}
              handleSelection={this.handleProjectTemplateSelection}
              placeHolderText={this.textMap.projectTemplate}
              disabled={!projectEligibleForUpdate}
            />

          </div>
        </div >;
    }
/*
    }
*/
    const locationContacts = localLocation && localLocation.location_users ? localLocation.location_users.map(user => {
      if (user && user.user) {
        return (
      <div key={'location-contact-' + user.user.id} className='location-contacts-row'>
        <div className='location-user-title'>{user.title ? user.title.toUpperCase() : 'NO TITLE'}</div>
        <div className='location-user-name'>{user.user.first_name} {user.user.last_name}</div>
      </div>);
      }
      else return null;
    }) : null;

    let locationEntry =
      <div className="column column-1">
        <div className="caption">{this.textMap.projectLocation}</div>
        <div className="entry-container">
          <div className="entry-field">
            <div className="label required">{this.textMap.markets.toUpperCase()}</div>
            <div id="marketPickerField" className="field combo">
              <ComboBox
                id={'marketPicker'}
                key={'marketPicker'}
                options={marketsList}
                currentOption={project.market ? { type: project.market.id, name: project.market.code, market: project.market } : null}
                hasBorder={false}
                underlined={false}
                defaultText="Select a Market"
                noneAvailabelText={loadingMarkets || this.state.starting ? this.textMap.noneSelected : undefined}
                width={259}
                small={true}
                height={20}
                displayFontStyle={{ fontSize: '12px' }}
                handleSelection={this.handleMarketSelection}
                placeHolderText={this.textMap.market}
                clearSelected={true}
                handleFetchOptions={this.getMarkets}
                disabled={!projectEligibleForUpdate || (project.project_users && project.project_users.length > 0) || (project.project_template && this.new_project_template === undefined) || (project.project_manager && this.new_project_manager === undefined) || loadingMarkets || loadingLocations || marketsList.length === 0}
              />
              {loadingMarkets && <LoadingDots />}
            </div>
          </div>
          <div className="entry-field">
            <div className="label required">{this.textMap.siteName.toUpperCase()}</div>
            <div id="locationPickerField" className={'field combo' + (!locationsList || locationsList.length === 0 ? ' inactive' : '')}>
              <ComboBox
                id={'locationPicker'}
                key={'locationPicker'}
                options={this.state.locationsList}
                showSearchBar={true}
                handleSearchValue={this.handleSearchLocation}
                currentOption={project.location || this.currentLocation}
                hasBorder={false}
                underlined={false}
                noneAvailabelText={loadingLocations || this.state.starting ? this.textMap.noneSelected : undefined}
                width={259}
                small={true}
                height={20}
                handleAddOption={this.handleLocationAdd}
                displayFontStyle={{ fontSize: '12px' }}
                handleSelection={this.handleLocationSelection}
                placeHolderText={this.textMap.location}
                clearSelected={true}
                handleFetchOptions={this.getLocations}
                disabled={!locationsList || locationsList.length === 0}
                dontSortMenu={true}
                handleCloseComboBox={this.handleCloseComboBox}
              />
              {loadingLocations && <LoadingDots />}
            </div>
          </div>
          <div className="entry-field">
            <div className="label required">{this.textMap.locationId.toUpperCase()}</div>
            <Input className={'field input-field guid-search' + (!locationsList || locationsList.length === 0 ? ' inactive' : '')} value={localLocation ? localLocation.guid : ''} onChange={this.handleSearchGuid}
              onKeyDown={this.handleKeyboardLocationSearch} ref={element => { this.searchElement = element; }} disabled={loadingLocations} />
          </div>
          <div className="address-field" id="address-cont">
            <div className="label">{this.textMap.address}</div>
            <div className="address"><p>{address1 || ''}</p><p>{address2 || ''}</p></div>
          </div>
          <div className="address-field latitude">
            <div className="label">{this.textMap.latitude}</div>
            <div className="address"><p>{(localLocation.latitude || localLocation.latitude === 0) ? localLocation.latitude : ''}</p></div>
          </div>
          <div className="address-field longitude">
            <div className="label">{this.textMap.longitude}</div>
            <div className="address"><p>{(localLocation.longitude || localLocation.longitude === 0) ? localLocation.longitude : ''}</p></div>
          </div>
          {project_typesPicker}
          {project_templatesPicker}
        </div>
        <div className='location-contacts'>
          <div className='caption'>Location Contacts</div>
          {locationContacts}
        </div>
      </div>;

    const notifyUsers = project.project_users ? project.project_users.filter(project_user => {
      if (project_user && project_user.assignment_type && project_user.assignment_type === 'notify' && !project_user.toBeDeleted) {
        return true;
      }
      else {
        return false;
      }
    }).map(ut => {
      return ut.user;
    }) : [];

    let notifyAvatars = null;
    if (notifyUsers.length > 1) {
      const notifyImages = this.createNotifyMemberArray(notifyUsers, 'notify');
      notifyAvatars = <div className="member-display">
        <div className="member-array">
          {notifyImages}
        </div>
      </div>;
    }

    let currentCustomer;
    const companyCustomers = this.state.customers ? this.state.customers.map(customer => {
      let selected = false;
      if (project && project.customers && project.customers.length > 0 && project.customers[0].id === customer.id) {
        currentCustomer = { type: customer.id, name: customer.name, selected };
        selected = true;
      }
      return { type: customer.id, name: customer.name, selected };
    }) : [];

    const projectContacts = this.renderProjectContacts();
    let projectManagersList=null;
    if(this.state.projectManagers){
      projectManagersList=this.state.projectManagers.filter(function(user){
        return !user.suspended;
      });  
    }
    return (

      <div className="project-crud" id={this.props.id}>
        {this.state.isCreateNewPGPopup && <CreateNewProjectGroup handleClosePopup={this.handleClosePopup} handleSavePG={this.handleSaveProjectGroup}/>}
        <div className="project-crud-header" id="project-crud-header">
          {addMemberPopup}
          <div className="project-info">
            <div className="project-identity">
              <div className="project-name">
                <div className={projectIsFavorite ? 'favorite' : ''}>
                </div>
                {project.name}
              </div>
              {/* <div className="guid">
                {"ID: " + project.guid}
              </div>
              <div className="guid">
                {"Contract ID: " + project.contract_id}
              </div> */}
              <div className='project-details'>
                <div className='details-ids'>
                  <div className="details-guid">
                    {project && project.guid ? 'ID: ' + project.guid : ''}
                  </div>
                  <div className="details-id">
                    {project && project.contract_id ? 'Contract ID: ' + project.contract_id : ''}
                  </div>
                </div>
                <div className="details-template">
                  {project && project.project_template && project.project_template.name ? 
                  'Created From Template: ' + project.project_template.name + ' | V' + project.project_template.version 
                  : ''}
                </div>
              </div>
            </div>
          </div>
          <div className="project-control">
            <div className="cancel-button" onClick={this.handleCancelProjectEdit} />
            <div className={'save-button' + (!projectHasBeenEdited && !isSaving ? ' disabled' : '') + (isSaving ? ' save-button--saving' : '')} onClick={(projectHasBeenEdited && !isSaving) ? this.handleSaveProject : null}>
              {isSaving ? (this.textMap.saving || 'SAVING') + '...' : this.textMap.save.toUpperCase() + ' ' + this.textMap.project.toUpperCase()}
            </div>
            <div className='divider' style={{ borderColor: accent_color }} />
            {memberSelector}
            {!this.props.allProjects && project &&
              <KeyMemberDisplay
                project={project}
                build={this.props.build}
                displayedUserInfo={this.state.displayedUserInfo}
                handleInfoOpen={this.handleInfoOpen}
                handleInfoClose={this.handleInfoClose}
                isLeftDividerHide={true}
              locationUsers={project && project.location ? project.location.location_users : null}
              projectContacts={project && project.project_contacts}
              />
            }
          </div>
        </div>
        <div className="project-crud-scroller">
          <div className="project-crud-body">
            {locationEntry}
            <div className="column column-2">
              <div className="caption">{this.textMap.projectInformation}</div>
              <div className="entry-container">
                <div className="entry-field">
                  <div className="label required">{this.textMap.name.toUpperCase()}</div>
                  <Input className="field input-field" value={project.name || ''} onChange={this.handleNameChange} id="projectNameInput"/>
                </div>
                <div className="entry-field">
                  <div className="label">{'PROJECT GROUP'}</div>
                  <div className="field combo">
                    <ComboBox
                      id={'projectGroupPicker'}
                      key={'projectGroupPicker'}
                      options={this.state.projectGroups}
                      currentOption={this.state.selectedGroup}
                      hasBorder={false}
                      underlined={false}
                      width={259}
                      small={true}
                      height={24}
                      displayFontStyle={{ fontSize: '12px' }}
                      handleSelection={this.handleProjectGroupSelection}
                      placeHolderText={this.textMap.customer}
                      clearSelected={!this.state.customFieldType}
                      showTooltip={true}
                    />
                  </div>
                </div>
                <div className="double-entry-field">
                  <div className="half-field">
                    <div className="label">{this.textMap.createDate.toUpperCase()}</div>
                    <div className="field inactive">{createDate}</div>
                  </div>
                  <div className="half-field">
                    <div className="label">{this.textMap.dueDate.toUpperCase()}</div>
                    {this.state.disableDatePicker ?
                      <div className="field inactive">{dueDate}</div> :
                      <div className="field">
                        <DatePicker
                          selected={project.due_date}
                          handleDateSelection={this.handleDueDateSelection}
                          minDate={moment()}
                          placeHolderText={'MM/DD/YYYY'}
                          width={126}
                          popperPlacement={'bottom-end'}
                          value={project.due_date}
                          dateFormat="MM/DD/YYYY"
                          onCalendarClose={this.onCalendarClose}
                        />
                      </div>}
                  </div>
                </div>
                <div className="double-entry-field">
                  <div className="half-field">
                    <div className="label">PROJECTED START DATE</div>
                    {project.status != 'not_started' ?
                      <div className="field inactive">{projectedStartDate}</div> :
                      <div className="field">
                        <DatePicker
                          selected={project.projected_start_date ? this.formatDate(project.projected_start_date): null}
                          handleDateSelection={this.handleProjectedStartDateSelection}
                          minDate={null}
                          placeHolderText={'MM/DD/YYYY'}
                          width={126}
                          popperPlacement={'bottom-end'}
                          value={project.projected_start_date ? this.formatDate(project.projected_start_date): null}
                          dateFormat="MM/DD/YYYY"
                          onCalendarClose={this.onCalendarClose}
                        />
                      </div>}
                  </div>
                  <div className="half-field">
                    <div className="label">ACTUAL START DATE</div>
                    <div className="field inactive">{actualStartDate}</div>
                  </div>
                </div>
                <div className="entry-field">
                  <div className="label">CONTRACT ID</div>
                  <Input className="field input-field" value={project.contract_id || ''} onChange={this.handleContractIdChange} />
                </div>
                <div className="entry-field">
                  <div className="label">PROJECT ID</div>
                  <Input className="field input-field" value={project.guid || ''} onChange={this.handleGuidChange} />
                </div>
                <div className="entry-field">
                  <div className="label">{this.textMap.customer.toUpperCase()}</div>
                  <div className="field combo">
                    <ComboBox
                      id={'customerPicker'}
                      key={'customerPicker'}
                      options={companyCustomers}
                      currentOption={currentCustomer}
                      hasBorder={false}
                      underlined={false}
                      width={259}
                      small={true}
                      height={24}
                      displayFontStyle={{ fontSize: '12px' }}
                      handleSelection={this.handleCustomerSelection}
                      placeHolderText={this.textMap.customer}
                      clearSelected={!this.state.customFieldType}
                    />
                  </div>
                </div>
                <div className="entry-field">
                  <div className="label">{this.textMap.projectManager.toUpperCase()}</div>
                  <div className="field combo">
                    <SelectUserComboBox
                      id={'pmPicker'}
                      width={259}
                      height={24}
                      hasBorder={false}
                      multiSelect={false}
                      small={true}
                      menuBelow={true}
                      displayFontStyle={{ fontSize: '12px' }}
                      handleSelection={this.handlePMSelection}
                      currentSelectedUser={project.project_manager}
                      users={projectManagersList}
                      defaultText={this.state.projectManagers ? null : 'First Select a Market'}
                    />
                  </div>
                </div>
                <div className="entry-field">
                  <div className="label">NOTIFY AFTER COMPLETION</div>
                  <div className="field combo">
                    <SelectUserComboBox
                      key="notify-user"
                      width={259}
                      hasBorder={false}
                      multiSelect={true}
                      height={24}
                      selectedUsers={notifyUsers}
                      menuBelow={true}
                      handleMultipleSelection={this.handleNotifyMultipleSelection}
                      small={true}
                      displayFontStyle={{ fontSize: '12px' }}
                      useMultiTab={true}
                      users={users}
                      defaultText={users && users.length > 0 ? null : 'Assign Project Members to add users'}
                    />
                  </div>
                  {notifyAvatars}
                </div>
              </div>
             {projectContacts}
            </div>
            <div className="column column-3">
              <div className="caption">{this.textMap.projectNotes}</div>
              <div className="entry-container">
                <div className="notes-field">
                  <div className="label">{this.textMap.notes.toUpperCase()}</div>
                  <Textarea className="field multi-line-input-field wide" onChange={this.handleNotesChange} value={project.notes ? project.notes : ''} />
                </div>
              </div>
              <div className="custom-fields">
                <div className="caption">{this.textMap.projectCustomFields}</div>
                <div className="custom-field-columns">
                  <div className="left-side">
                    <div className="entry-container">
                      <div className="entry-field">
                        <div className="label">{this.textMap.fieldType.toUpperCase()}</div>
                        <div id="customFieldField" className="field combo">
                          <ComboBox
                            id={'customFieldTypePicker'}
                            key={'customFieldTypePicker'}
                            options={this.customFieldTypes}
                            currentOption={currentFieldType}
                            hasBorder={false}
                            underlined={false}
                            width={259}
                            small={true}
                            height={24}
                            displayFontStyle={{ fontSize: '12px' }}
                            handleSelection={this.handleCustomFieldTypeSelection}
                            placeHolderText={this.textMap.fieldType}
                            clearSelected={!this.state.customFieldType}
                          />
                        </div>
                      </div>
                      <div className="entry-field">
                        <div className="label">{this.textMap.fieldLabel.toUpperCase()}</div>
                        <Input className="field input-field" value={this.state.customSetting.setting_label || ''} data-id="setting-label" onChange={this.handleValueChanged} />
                      </div>
                      <div className="notes-field small">
                        <div className="label">{this.textMap.notesInstructions.toUpperCase()}</div>
                        <Textarea className="field multi-line-input-field" value={this.state.customSetting.notes ? this.state.customSetting.notes : ''} data-id="setting-notes" onChange={this.handleValueChanged} />
                      </div>
                      {settingEditor}
                      <div className="add-setting-footer">
                        <div className="cancel-button" onClick={this.handleCancelCustomSetting} />
                        <div className={`add-button ${!this.state.customSetting.setting_label ? 'disabled' : ''} `} onClick={!this.state.editingCustomField ?
                          this.handleAddCustomSetting : this.handleSettingUpdate}>
                          {!this.state.editingCustomField ? this.textMap.add.toUpperCase() :
                            this.textMap.update.toUpperCase()}</div>
                      </div>
                    </div>
                  </div>
                  <div className="right-side">
                    <div className="custom-fields-list">
                      <DataCollector fields={project.custom_project_settings ? project.custom_project_settings : []}
                        handleChanges={this.handleFieldChanges}
                        handleSettingEdit={this.handleSettingEdit}
                        handleSettingDelete={this.handleSettingDelete}
                        selectedField={this.state.customSetting}
                        height={265} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {

  return {
    dataModel: dataModel,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectCRUD));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/index.js